export enum TaskStatus {
  'TODO' = 'TODO',
  'IN_PROGRESS' = 'IN_PROGRESS',
  'DONE' = 'DONE',
}

export enum TaskPriority {
  LOW = 0,
  MEDIUM = 1,
  HIGH = 2,
}

export enum TaskType {
  OTHER = 'OTHER',
}
